import {Fancybox} from "@fancyapps/ui/dist/fancybox/";

import testFnc from "./components/test";
import {swipers} from "./components/swipers";
import {animation} from "./components/animation";
import {form} from "./components/form";
import {runLine} from "./components/runLine";
import {initCasesGalleries} from "./components/initCasesGalleries";
import headerBurger from "./components/headerBurger";

import {cookies} from "./components/cookies";

Fancybox.bind("[data-fancybox]", {});

testFnc();
swipers()
animation()
runLine()
form()
initCasesGalleries()
cookies()
headerBurger()
